import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FiChevronDown, FiChevronRight, FiGrid, FiTag } from 'react-icons/fi';
import useActiveMenu from './useActiveMenu';

const API = "https://admin.bridge365.in/wp-json/wc/v3";
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";

const decodeHtmlEntities = (text = '') => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

function Topmenuleft() {
  const [categories, setCategories] = useState([]);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const categoryMenuRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    fetch(`${API}/products/categories?per_page=100&consumer_key=${CK}&consumer_secret=${CS}`)
      .then(res => res.json())
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        setCategories(
          list
            .filter(cat => cat.slug !== 'uncategorized' && cat.name?.toLowerCase() !== 'uncategorized')
            .map(cat => ({ ...cat, name: decodeHtmlEntities(cat.name) }))
        );
      })
      .catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (categoryMenuRef.current && !categoryMenuRef.current.contains(event.target)) {
        setIsCategoryMenuOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsCategoryMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  useEffect(() => {
    setIsCategoryMenuOpen(false);
  }, [location.pathname]);

  // Parent categories
  const parentCats = categories.filter(cat => cat.parent === 0);

  // Get subcategories
  const getSubCats = (parentId) => {
    return categories.filter(cat => cat.parent === parentId);
  };

  const { isHomeActive, isCategoryActive, isExactCategoryActive } = useActiveMenu(categories);

  return (
<>
<div className='col-md-3'>
    <div className="category-menu" ref={categoryMenuRef}>
      <button
        className="category-menu-toggle"
        type="button"
        aria-expanded={isCategoryMenuOpen}
        aria-controls="categoryDropdown"
        onClick={() => setIsCategoryMenuOpen(open => !open)}
      >
        <FiGrid className="category-toggle-grid" />
        <span>Explore All Categories</span>
        <FiChevronDown className={`category-toggle-arrow${isCategoryMenuOpen ? ' open' : ''}`} />
      </button>

      {isCategoryMenuOpen && (
        <ul className="category-dropdown" id="categoryDropdown">
          {parentCats.map(parent => {
            const subCats = getSubCats(parent.id);
            const hasSubCats = subCats.length > 0;

            return (
              <li
                key={parent.id}
                className={`category-dropdown-item${hasSubCats ? ' has-submenu' : ''}`}
              >
                <Link className="category-dropdown-link" to={`/category/${parent.id}`}>
                  <span className="category-dropdown-icon">
                    <FiTag />
                  </span>
                  <span>{parent.name}</span>
                  {hasSubCats && <FiChevronRight className="category-child-arrow" />}
                </Link>

                {hasSubCats && (
                  <ul className="category-submenu">
                    {subCats.map(sub => (
                      <li key={sub.id} className="category-submenu-item">
                        <Link className="category-submenu-link" to={`/category/${sub.id}`}>
                          {sub.name}
                          <FiChevronRight className="category-submenu-arrow" />
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
    </div>


<div className='col-md-9'>
    <nav className="desktop-menu navbar navbar-expand-lg">

      <div className="navbar-collapse">
        <ul className="navbar-nav">

          <li className="nav-item">
            <NavLink
              className={`nav-link${isHomeActive ? ' active' : ''}`}
              to="/home"
            >
              Home
            </NavLink>
          </li>

         

       
           

          

              {parentCats.map(parent => (
                <li
                  key={parent.id}
                  className={`nav-item${isCategoryActive(parent.id) ? ' active' : ''}`}
                >
                  <Link
                    className={`nav-link${isCategoryActive(parent.id) ? ' active' : ''}`}
                    to={`/category/${parent.id}`}
                  >
                    {parent.name}
                  </Link>

                  {getSubCats(parent.id).length > 0 && (
                    <ul className="dropdown-menu">
                      {getSubCats(parent.id).map(sub => (
                        <li key={sub.id}>
                          <Link
                            className={`dropdown-item${isExactCategoryActive(sub.id) ? ' active' : ''}`}
                            to={`/category/${sub.id}`}
                          >
                            {sub.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
        

        </ul>
      </div>

    </nav>
    </div>
    </>
  );
}

export default Topmenuleft;
